// ページ内ナビゲーションのコントロール
const pageNavigationSub = document.querySelector('.in-page-navigation .sub-navigation');
const pageMainContent = document.querySelectorAll('.main-content section');
const observerOptions = {
  rootMargin: "-50% 0px",
  threshold: 0,
};
const intersectionObserver = new IntersectionObserver(contentIntersection, observerOptions);

// 交差のを検知した場合にnavigationControlに交差したコンテンツを渡す
function contentIntersection(entries) {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      navigationControl(entry.target);
    }
  });
}

// 交差しているセクションとサイドナビゲーションのhref属性の中身を比較して一致している場合に、エレメントに対してactiveを追加する
function navigationControl(intersectingContent) {
  [...pageNavigationSub.children].forEach(element => {
    const subNavigationLink = element.firstElementChild;
    const subNavigationLinkHref = subNavigationLink.getAttribute('href');
    const intersectingContentID = intersectingContent.getAttribute('id');

    subNavigationLink.classList.remove('active');

    if (subNavigationLinkHref.includes(intersectingContentID)) {
      subNavigationLink.classList.add('active');
    }
  });
}

pageMainContent.forEach(element => intersectionObserver.observe(element));